import React from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { CheckCircle, Calendar, Users, Mail } from "lucide-react";

export default function BidRequestSuccess() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/10 to-accent/10 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full space-y-8">
        {/* Success Header */}
        <div className="text-center space-y-4">
          <div className="mx-auto w-20 h-20 bg-success/10 rounded-full flex items-center justify-center">
            <CheckCircle className="w-12 h-12 text-success" />
          </div>
          <h1 className="text-3xl font-bold text-foreground">
            Thank you for your interest! 🎲
          </h1>
          <p className="text-lg text-foreground">
            Your bid request was submitted successfully. We appreciate your
            interest in our casino event services!
          </p>
        </div>

        {/* Main Content Card */}
        <Card className="shadow-lg">
          <CardHeader className="text-center">
            <CardTitle className="text-xl text-foreground">
              What happens next?
            </CardTitle>
            <CardDescription>
              Here's what you can expect in the coming days
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            {/* Step 1 */}
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                <Mail className="w-5 h-5 text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-foreground">
                  Check your email
                </h3>
                <p className="text-sm text-muted-foreground mt-1">
                  We've sent you a confirmation email with your bid request
                  details. Our team will review your submission soon.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                <Users className="w-5 h-5 text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-foreground">
                  Our team will contact you
                </h3>
                <p className="text-sm text-muted-foreground mt-1">
                  A member of our staff will reach out soon to discuss your
                  event, answer any questions, and help you plan an
                  unforgettable experience.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                <Calendar className="w-5 h-5 text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-foreground">
                  Get ready for your event!
                </h3>
                <p className="text-sm text-muted-foreground mt-1">
                  Once everything is confirmed, we'll help you finalize the
                  details and make sure your casino event is a success.
                </p>
              </div>
            </div>

            {/* Important Note */}
            <div className="bg-primary/5 border border-border rounded-lg p-4 mt-6">
              <p className="text-sm text-muted-foreground">
                <strong>Note:</strong> Submitting a bid request does not
                guarantee event booking. Our team will follow up to confirm
                availability and next steps.
              </p>
            </div>
          </CardContent>
        </Card>

        {/* Footer Note */}
        <div className="text-center">
          <p className="text-sm text-muted-foreground">
            Questions? Issues? Feel free to reach out to our support team
            anytime.
          </p>
        </div>
      </div>
    </div>
  );
}
